export default {
  name: "EventAppleNoticeModal",
  data: function data() {
    return {
      visible: false,
      isAgree: false,
      content: ''
    };
  },
  methods: {
    show: function show(content) {
      if (content == '' || content == null) {
        return;
      }
      this.visible = true;
      this.content = content;
    },
    change: function change(e) {
      console.log(e);
      this.isAgree = e.target.checked;
    },
    start: function start() {
      if (this.isAgree) {
        this.visible = false;
      } else {
        this.$message.info("请阅读并勾选");
      }
    }
  }
};